<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			height="60vh"
		>
			<el-table-column prop="id" label="id" width="70px"> </el-table-column>
			<el-table-column prop="title" label="标题" width="200px">
			</el-table-column>
			<el-table-column label="类型" width="70px">
				<template slot-scope="scope">
					<span v-if="scope.row.type == 1">文章</span>
					<span v-if="scope.row.type == 2">快讯</span>
					<span v-if="scope.row.type == 55">专栏</span>
					<span v-if="scope.row.type == 7">活动</span>
				</template>
			</el-table-column>
			<el-table-column prop="desc" label="描述内容" min-width="200px">
			</el-table-column>
			<el-table-column prop="object_id" label="内容ID" width="90px">
			</el-table-column>
			<el-table-column prop="add_time" label="时间" width="200px">
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { statusReport } from "@/api/information";
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		toDetail(row) {
			this.$router.push({
				path: "/reportinfodetail",
				query: { id: row.id },
			});
		},
	},
};
</script>

<style scoped></style>
